import { render, staticRenderFns } from "./EditHotspotsModal.vue?vue&type=template&id=765b65e6"
import script from "./EditHotspotsModal.vue?vue&type=script&lang=js"
export * from "./EditHotspotsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports